import { useCallback } from "react";
import Select, { SelectOption } from "@/components/shared/select";
import { FieldGroup } from "../parts/FieldGroup";
import styles from "../AutomationConfiguration.module.scss";
import { useSimulator } from "@/v2/features/simulator/context/SimulatorWrapper";
import { toast } from "sonner";

const interactionLimitOptions: SelectOption[] = [
  ...[...Array(6)].map((_, i) => ({
    label: `${i + 1} user interaction${i > 0 ? "s" : ""}`,
    value: (i + 1).toString(),
  })),
  { label: "Unlimited", value: "unlimited" },
];

export function InteractionLimitField() {
  const { updateRelease, currentRelease } = useSimulator();
  const handleOnChange = useCallback(
    (newValue: string) => {
      if (currentRelease?.id) {
        updateRelease(String(currentRelease.id), {
          simulatorId: currentRelease.simulatorId,
          maxBackAndForth:
            newValue === "unlimited" ? 400 : parseInt(newValue),
        });
      } else {
        toast.error("Something went wrong, please try again");
      }
    },
    [currentRelease, updateRelease]
  );

  return (
    <FieldGroup
      label={"Interaction limit"}
      description={
        "Set the maximum number of user interactions before escalations."
      }
    >
      <Select
        options={interactionLimitOptions}
        value={currentRelease?.maxBackAndForth?.toString() === "400" ? "unlimited" : currentRelease?.maxBackAndForth?.toString()}
        onChange={handleOnChange}
        classes={{ trigger: styles.Select }}
      />
    </FieldGroup>
  );
}
